module.exports = __webpack_public_path__ + "img/moon-with-clouds.855084ec.png";